module.exports = __webpack_public_path__ + "img/blog-details-1.4a2acef7.jpg";